import { render } from "./Assistance.vue?vue&type=template&id=4b2d8ee9"
import script from "./Assistance.vue?vue&type=script&lang=js"
export * from "./Assistance.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__